module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cdad5959f5916f1de3a6e086b7756c2c.png";